 <template lang="pug">
  validation-observer(ref='validation' tag='form')
    div
      el-card(shadow="hover").card-container
        h3 Dados da Ordem de Serviço
        el-row(:gutter="30")
          el-col.container-input(:span="18")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(label="Nº da Ordem de Serviço:", :required="true")
              el-input.input(
                v-model="ordemServico.numero",
                name="Numero",
                :maxlength="50",
                :class="{'erro' : errors.length || numeroExistente}",
                :required="true"
                @blur="checaNumeroOs"
              )
              span.help.erro {{ errors[0] }}
          el-col.container-input(:span="6")
            validation-provider(rules="required", v-slot="{ errors }")
              app-label(label="Municipio:", :required="true")
              el-select.input(
                @keyup.native.enter="consultar"
                clearable,
                filterable,
                default-first-option=false,
                name="municipio",
                :class="{'erro' : errors.length}",
                v-model="ordemServico.municipio.id",
              )
                el-option(
                  v-for="item in municipios",
                  :key="item.id",
                  :label="item.nome",
                  :value="item.id",
                )
              span.help.erro {{ errors[0] }}
        el-col.container-input
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(
              label="Upload da Ordem de Serviço",
              :required="true"
            )
            app-anexo(
              :id="'upload-ordem-servico'"
              @removeFile="removeFile",
              @uploadFile="uploadFile",
              @downloadDocumentoCadastro="download"
              :files="documentos",
              :showAnexar="documentos.length === 0"
              :errors="errors",
              scope="documentos",
              v-model="documentos")
      app-listagem(
        :showButton="false"
        :json-headers="headers"
        :json-data="analistas"
        :totalElements="totalElements"
        :pagina="pagina"
        :headerLabel="'Vincular Equipe'"
        :hasRefreshButton="true"
        :busca="true"
        :paginate="true"
        @selectItem="selecionaItem"
        @updateListagem="buscar"
        @changePage="changePage"
        @changeTotal="changeTotal"
        :expandir="false"
      )
</template>

<script>
import axios from '@/utils/api'
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppListagem from '@/components/AppListagem.vue'
import AppAnexo from '@/components/AppAnexo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileSaver from 'file-saver'

export default {
  components: {
    AppListagem,
    AppAnexo,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    numero: {
      required: true
    },
    usuario: {
      required: true
    },
    ordemServico: {
      required: true
    },
    analistas: {
      required: true
    },
    analistasSelecionados: {
      required: true
    },
    buscar: {
      required: true
    }
  },

  data () {
    return {
      headers: [
        { id: 1, titulo: 'Nome', propriedade: 'nome', acoes: 0, marcado: () => true, filter: false, sortable: false },
        { id: 2, titulo: 'Quantidade. OS', propriedade: 'quantidadeOrdemServico', acoes: 0, marcado: false, filter: true, sortable: false }
      ],
      validation: {
        valid: true,
        extensions: ['.dwg', '.zip', '.rar', '.doc', '.pdf', '.jpeg', '.png', '.docx', '.dxf', '.shp', '.xls', '.xlsx', '.ods']
      },
      numeroExistente: false,
      documentos: [],
      municipios: [],
      pagina: 0,
      totalElements: 0
    }
  },

  async created () {
    this.municipios = await this.findMunicipiosByUf(process.env.ESTADO)
  },

  methods: {
    ...mapActions({
      verificaNumeroOs: 'ordemServico/verificaNumeroOs',
      findMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    async checkValidacao () {
      const valido = await this.$refs.validation.validate()

      if (this.numeroExistente) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Já existe uma Ordem de Serviço com este número!')
        return false
      }

      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }

      if (this.analistasSelecionados.length === 0) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, selecione ao menos um analista.')
        return false
      }
      return true
    },

    selecionaItem (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.ordemServico.responsaveis.push({ responsavel: { ...item } })
      } else {
        this.ordemServico.responsaveis = this.ordemServico.responsaveis.filter((responsavel) => responsavel.responsavel.id !== item.id)
      }
    },

    async checaNumeroOs () {
      this.numeroExistente = await this.verificaNumeroOs({ numero: this.ordemServico.numero, id: this.ordemServico.id })
      if (this.numeroExistente) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Já existe uma Ordem de Serviço com este número!')
      }
    },

    async uploadFile (file) {
      this.documentos = [{ key: file.response, nome: file.name }]
    },

    async download (file) {
      const response = await axios({
        method: 'POST',
        url: `anexoMensagem/download?isFormatKey=false`,
        data: file,
        responseType: 'blob'
      })
      FileSaver.saveAs(response, file.nome)
    },

    removeFile (file) {
      this.documentos.splice(this.documentos.findIndex(f => f === file), 1)
    },

    changePage (page) {
      this.pagina = page - 1
    },

    changeTotal (total) {
      this.totalElements = total
    }
  },

  watch: {
    ordemServico: {
      handler: function (val, oldVal) {
        if (val.documento) {
          this.documentos = [val.documento]
        }
        this.$emit('setOrdemServico', val)
      },
      immediate: true,
      deep: true
    },
    documentos: {
      handler: function (val) {
        if (val.length) {
          this.ordemServico.documento = val[0]
        }
      }
    }
  }

}
</script>
<style scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ordemServico/DadosOrdemServico.vue